import {List, Map, Record, type RecordOf} from 'immutable';
import {
  DEFAULT_ORDERS_SORT_COLUMN,
  DEFAULT_ORDERS_SORT_DIRECTION,
  NO_STATUS_FILTER,
  type OrderStatusFilter,
} from './constants';
import type {Price} from '@packages/systems/commerce/core';

type UIOrderRecordProps = {
  selected: boolean;
};

// @ts-expect-error - TS2322 - Type 'Factory<{ selected: false; }>' is not assignable to type 'Factory<UIOrderRecordProps>'.
export const UIOrderStateRecord: Record.Factory<UIOrderRecordProps> = Record(
  {
    selected: false,
  },
  'UIOrderStateRecord'
);

export type UIOrderRecordType = RecordOf<UIOrderRecordProps>;
type EditorOrderPaneProps = {
  orderIdsList: List<string>;
  ordersUIState: Map<string, UIOrderRecordType>;
  bulkSelecting: boolean;
  statusFilter: OrderStatusFilter;
  textFilter: string;
  sortBy: string;
  sortDirection: string;
  selectedOrderId: string | null;
  lastSelectedIndex: number | null;
  orderCount: number;
  totalRevenue: Price | null | undefined;
  averageOrderSize: number | null | undefined;
  averageOrderValue: Price | null | undefined;
};

export type EditorOrderPaneRecordType = RecordOf<EditorOrderPaneProps>;

// @ts-expect-error - TS2322 - Type 'Factory<{ orderIdsList: List<string>; ordersUIState: Map<string, UIOrderRecordType>; bulkSelecting: false; statusFilter: "all"; textFilter: string; sortBy: string; ... 6 more ...; averageOrderValue: null; }>' is not assignable to type 'Factory<EditorOrderPaneProps>'.
export const EditorOrderPaneRecord: Record.Factory<EditorOrderPaneProps> =
  Record(
    {
      orderIdsList: List(),
      ordersUIState: Map(),
      bulkSelecting: false,
      statusFilter: NO_STATUS_FILTER,
      textFilter: '',
      sortBy: DEFAULT_ORDERS_SORT_COLUMN,
      sortDirection: DEFAULT_ORDERS_SORT_DIRECTION,
      selectedOrderId: null,
      lastSelectedIndex: null,
      orderCount: 0,
      totalRevenue: null,
      averageOrderSize: null,
      averageOrderValue: null,
    },
    'EditorOrderPaneRecord'
  );
